module.exports = __webpack_public_path__ + "static/media/headerLogo.f19c3add.png";